import styled, { css } from 'styled-components';
import NextLink from 'next/link';
import ArrowLink from 'Elements/Link/Arrow';

export const Container = styled.article<{ $useSimplifiedMobileLayout: boolean }>`
    ${({ theme, $useSimplifiedMobileLayout }) => css`
        position: relative;
        overflow: hidden;
        height: 100%;
        display: flex;
        flex-direction: column;
        border-radius: 0.5rem;
        background-color: var(--card-bg-colour, ${theme.colors.background.hex});

        ${$useSimplifiedMobileLayout &&
        css`
            flex-direction: row;
            align-items: center;
            gap: 1rem;

            ${Description}, ${StyledArrowLink} {
                display: none;
            }

            @media ${theme.breakpoints.large.media} {
                flex-direction: column;
                gap: unset;

                ${Description}, ${StyledArrowLink} {
                    display: inline-flex;
                }
            }
        `}
    `}
`;

export const SimplifiedMobileLink = styled(NextLink)`
    ${({ theme }) => css`
        position: absolute;
        inset: 0;
        z-index: 1;

        @media ${theme.breakpoints.large.media} {
            display: none;
        }
    `}
`;

export const ImageWrapper = styled.div<{
    $includeInnerPadding: boolean;
    $useSimplifiedMobileLayout: boolean;
}>`
    ${({ theme, $includeInnerPadding, $useSimplifiedMobileLayout }) => css`
        position: relative;
        width: 100%;
        height: 7rem;
        margin-bottom: 1rem;
        overflow: hidden;
        flex: 0 0 auto;
        border-radius: ${$includeInnerPadding ? '0.5rem 0.5rem 0 0' : '0.5rem'};

        @media ${theme.breakpoints.medium.media} {
            height: 8rem;
        }

        @media ${theme.breakpoints.large.media} {
            height: 11rem;
        }

        ${$useSimplifiedMobileLayout &&
        css`
            width: 40%;
            height: 5.25rem;
            margin-bottom: 0;

            @media ${theme.breakpoints.medium.media} {
                height: 5.25rem;
            }

            @media ${theme.breakpoints.large.media} {
                width: 100%;
                height: 11rem;
                margin-bottom: 1rem;
            }
        `}
    `}
`;

export const Content = styled.div<{ $includeInnerPadding: boolean }>`
    ${({ $includeInnerPadding }) => css`
        display: flex;
        flex-direction: column;
        flex-grow: 1;

        *:last-child {
            margin-bottom: 0;
        }

        ${$includeInnerPadding &&
        css`
            padding: 0 1rem 1rem;
        `}
    `}
`;

export const Heading = styled.h3<{ $useSimplifiedMobileLayout: boolean }>`
    ${({ theme, $useSimplifiedMobileLayout }) => css`
        font-size: 1.125rem;
        line-height: 1.3;
        font-weight: 700;
        color: var(--card-h-colour, ${theme.colors.tertiary.hex});
        margin: 0;

        @media ${theme.breakpoints.large.media} {
            font-size: 1.5rem;
        }

        ${$useSimplifiedMobileLayout &&
        css`
            text-decoration: underline;

            @media ${theme.breakpoints.large.media} {
                text-decoration: none;
            }
        `}
    `}
`;

export const Description = styled.p`
    font-size: 1.125rem;
    margin-top: 0.75rem;
`;

export const StyledArrowLink = styled(ArrowLink)`
    font-size: 1rem;
    position: unset;

    &:before {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        z-index: 1;
    }
`;
